import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=353029a2&scoped=true&"
import script from "./TermsOfService.vue?vue&type=script&lang=ts&"
export * from "./TermsOfService.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=353029a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353029a2",
  null
  
)

export default component.exports